import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import {
  AUTH_PREFIX_PATH,
  UNAUTHENTICATED_ENTRY,
  REDIRECT_URL_KEY,
  AUTHENTICATED_ENTRY,
} from "configs/AppConfig";

import { useAuthenticator } from "@aws-amplify/ui-react";

const HomeRoute = () => {
  const { authStatus, route } = useAuthenticator((context) => [context.route]);
  const isSignedIn = authStatus === "authenticated";
  const location = useLocation();
  console.log("HomeRoute", {
    authStatus,
    route,
    location: location.pathname,
  });

  if (!isSignedIn) {
    if (authStatus === "configuring") {
      return <Loading cover="content" />;
    }
    return <Navigate to={UNAUTHENTICATED_ENTRY} replace />;
  } else {
    return <Navigate to={AUTHENTICATED_ENTRY} replace />;
    // return <Navigate to={`${AUTH_PREFIX_PATH}/login`} replace />;
  }
};

export default HomeRoute;
